<template>
  <ButtonComponent v-bind="attrs" @click="submit" class="upsell-trigger" />
</template>

<script>
import Bus from '@/bus'
import Items from './items'

export default {
  props: {
    value: String,
  },
  computed: {
    item() {
      return Items.find(i => i.id === this.value)
    },
    attrs() {
      return {
        label: this.item.triggerLabel,
        ...this.$attrs,
      }
    },
  },
  methods: {
    submit() {
      Bus.$emit('upsell:show', this.value)
    },
  },
}
</script>

<style lang="scss">
.upsell-trigger {
}
</style>
